// eslint-disable-next-line import/prefer-default-export
export const DANGER_TYPE = 'danger';
